// API Configuration
export const API_CONFIG = {
  // Base URL for API endpoints
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://testapi.identxlabs.com',

  // API endpoints
  ENDPOINTS: {
    CLIENTS: '/admin/clients',
    ONBOARD_CLIENT: '/admin/onboardNewClient',
    UPDATE_CLIENT: (id) => `/admin/clients/${id}`,
    DEACTIVATE_CLIENT: () => `/admin/changeStatus`,
    DELETE_CLIENT: () => `/admin/deleteClient`,
    CLIENT_DETAILS: (id) => `/admin/clients/${id}`,
    ADMIN_ME: '/admin/me'
  },

  // Request timeout (in milliseconds)
  TIMEOUT: 30000,

  // Retry configuration
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000,
  },

  API_NAME: 'identx'
};

// Check if API is properly configured
export const isApiConfigured = () => {
  return !!process.env.REACT_APP_API_BASE_URL;
};

// Get API endpoint
export const getApiEndpoint = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Log API configuration status
if (!isApiConfigured()) {
  console.warn('⚠️  REACT_APP_API_BASE_URL is not configured. Please set it in your .env file.');
  console.warn('   Example: REACT_APP_API_BASE_URL=https://your-api-endpoint.com');
}
